import Container from "../di/container";

export const CameraZoom = (zoom: number, duration: number = 1000) => {
    Container.getMainScene().cameraZoom(zoom, duration);
    console.log('Camera zoom: ' + zoom);
}